module.exports = __webpack_public_path__ + "images/stuffs/stuff-holding-card.svg";